import { render, staticRenderFns } from "./SoundAlarm.vue?vue&type=template&id=1c540d84&scoped=true"
import script from "./SoundAlarm.vue?vue&type=script&lang=js"
export * from "./SoundAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c540d84",
  null
  
)

export default component.exports